var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 21.25H4.6875C4.16975 21.25 3.75 21.6697 3.75 22.1875C3.75 22.7053 4.16975 23.125 4.6875 23.125H8.4375C8.95525 23.125 9.375 22.7053 9.375 22.1875C9.375 21.6697 8.95525 21.25 8.4375 21.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 17.5H4.6875C4.16975 17.5 3.75 17.9197 3.75 18.4375C3.75 18.9553 4.16975 19.375 4.6875 19.375H8.4375C8.95525 19.375 9.375 18.9553 9.375 18.4375C9.375 17.9197 8.95525 17.5 8.4375 17.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.875 15.8029V5.9375C26.875 5.82506 26.8548 5.71356 26.8153 5.60831L24.9403 0.608312C24.8031 0.242437 24.4533 0 24.0625 0H2.8125C2.42169 0 2.07188 0.242437 1.93469 0.608312L0.0596875 5.60831C0.0201875 5.71356 0 5.82506 0 5.9375V25.9375C0 26.4552 0.41975 26.875 0.9375 26.875H15.8029C17.0929 29.8855 20.0853 32 23.5625 32C28.2149 32 32 28.2149 32 23.5625C32 20.0853 29.8855 17.0929 26.875 15.8029ZM23.4128 1.875L24.5847 5H16.7651L16.3744 1.875H23.4128ZM12.3901 1.875H14.4849L14.8755 5H11.9994L12.3901 1.875ZM11.875 6.875H15V10.3125L14 9.5625C13.6667 9.3125 13.2083 9.3125 12.875 9.5625L11.875 10.3125V6.875ZM3.46219 1.875H10.5006L10.1099 5H2.29031L3.46219 1.875ZM15.2481 25H1.875V6.875H10V12.1875C10 12.9601 10.8819 13.401 11.5 12.9375L13.4375 11.4844L15.375 12.9375C15.9931 13.401 16.875 12.9601 16.875 12.1875V6.875H25V15.2481C24.5327 15.1675 24.0525 15.125 23.5625 15.125C18.9101 15.125 15.125 18.9101 15.125 23.5625C15.125 24.0525 15.1675 24.5327 15.2481 25ZM23.5625 30.125C19.9439 30.125 17 27.1811 17 23.5625C17 19.9439 19.9439 17 23.5625 17C27.1811 17 30.125 19.9439 30.125 23.5625C30.125 27.1811 27.1811 30.125 23.5625 30.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5268 21.1127L22.3472 25.2923L20.5982 23.5434C20.2413 23.1865 19.6598 23.1536 19.2864 23.4933C18.8878 23.8561 18.8768 24.4737 19.2536 24.8505L21.6842 27.2811C22.0503 27.6472 22.6439 27.6472 23.01 27.2811L27.8713 22.4198C28.2481 22.0431 28.2372 21.4254 27.8385 21.0626C27.4652 20.7228 26.8837 20.7557 26.5268 21.1127Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageIcon);
export default __webpack_public_path__ + "static/media/package-icon.9f0b669c2d2d9d4018319260b6f0c207.svg";
export { ForwardRef as ReactComponent };